

<template>
  <div class="floor" v-loading="loading">
    <h2>{{dataForm.title}}</h2>
    <div class="floor-tabs">
      <el-tabs v-model="dataForm.activeName" type="card">
        <el-tab-pane
          v-for="(item,index) in dataForm.tabList"
          :label="item.title"
          :name="index+''"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="floor-box">
      <!-- 左侧 -->
      <div class="floor-left">
        <!-- 左侧商品类型导航列表 -->
        <div class="floor-left__top" :style="{background:dataForm.LeftBackgroundColor}">
          <el-row :gutter="3">
            <el-col :span="8" v-for="(item,i) in dataForm.leftNavList" :key="i">
              <div class="goods—type__link" :style="{color:dataForm.LeftFontColor}">
                <span @click="toGoodsType(item)">{{ item.titleName }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 左侧热图区 -->
        <div class="floor-left__footer" @click="toImg(0)">
          <img :src="dataForm.leftImg.url" />
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="floor-content">
        <div class="tabsBar" v-for="(items,index) in dataForm.tabList" :key="index">
          <mall-goods
            :msg="item"
            v-if="(index + '') === dataForm.activeName"
            v-for="(item,i) in items.children"
            :key="i"
            :usage="usage"
            :showBtn="showBtn"
          ></mall-goods>
        </div>
      </div>
      <!-- 右侧热图区 -->
      <div class="floor-right">
        <div class="floor-right__top" @click="toImg(1)">
          <img :src="dataForm.rightImg1.url" />
        </div>
        <div class="floor-right__footer" @click="toImg(2)">
          <img :src="dataForm.rightImg2.url" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import YButton from "/components/YButton";
import mallGoods from "/components/mallGoods";
import { addCart, getCartCount, getAllGoods } from "/api/goods.js";
import { mapMutations, mapState } from "vuex";
import { openToLink } from "/utils/openToLink";

export default {
  components: {
    YButton,
    mallGoods
  },
  name: "floor",
  props: {
    data: {
      type: Object
    },
    usage: {
      type: String
    }
  },
  data() {
    return {
      loading:false,
      dataForm: this.data.data,
      activeName: 0,
      itemIdList: [],
      tabList: [],
      goodsList: []
    };
  },
  computed: {
    ...mapState(["login", "showCart"]),
    showBtn() {
      return this.usage !== "store";
    }
  },
  created() {
    let itemIdList = [];
    let tabList = [];
    this.dataForm.tabList.forEach(item => {
      tabList.push({
        title: item.title,
        uuid: item.uuid,
        uuid2: item.uuid2,
        children:[],
        childrenIdList: item.children.map(row => {
          itemIdList.push(row.item_id);
          return row.item_id;
        })
      });
    });
    this.itemIdList = itemIdList;
    this.tabList = tabList;
    this._getAllGoods(itemIdList);
  },
  methods: {
    ...mapMutations([
      "ADD_CART",
      "ADD_ANIMATION",
      "SHOW_CART",
      "UPDATE_CARTCOUNT"
    ]),
    toLinkState(type, data) {
      openToLink(type, data);
    },

    toImg(i) {
      if (i === 0) {
        if (!this.dataForm.leftImg.children) return;
        let { children } = this.dataForm.leftImg;
        this.toLinkState(children.type, children.data);
      } else if (i === 1) {
        if (!this.dataForm.rightImg1.children) return;
        let { children } = this.dataForm.rightImg1;
        this.toLinkState(children.type, children.data);
      } else if (i === 2) {
        if (!this.dataForm.rightImg2.children) return;
        let { children } = this.dataForm.rightImg2;
        this.toLinkState(children.type, children.data);
      }
    },
    /**
     * 跳转商品列表页 并且带着商品类型
     */
    toGoodsType(row) {
      openToLink(row.linkPage, row);
    },
    /**
     * 跳转商品详情页
     */
    toGoodsDetails(row) {
      let href = `/#/goodsDetails?itemId=${row.itemId}`;
      window.open("//" + window.location.host + href);
    },
    /**
     * 加入购物车
     */
    _addCart(type, id, price, name, img) {
      if (type === "drug") {
        //预约单
        this._rxAddCart(id);
        return;
      }
      if (!this.login) {
        this.$router.push({ path: "/login" });
        return;
      }
      const params = {
        item_id: id,
        num: 1,
        shop_type: "distributor",
        cart_type: "cart"
      };
      addCart(params).then(res => {
        this._getCartCount();
        this.$message({ message: "添加成功!", type: "success" });
      });
    },
    _getCartCount() {
      const params = { shop_type: "distributor" };
      getCartCount(params).then(({ data }) =>
        this.UPDATE_CARTCOUNT(data.item_count)
      );
    },
    /**
     * 加入预约单
     */
    _rxAddCart(id) {
      if (this.login) {
        const params = {
          item_id: id,
          num: 1,
          shop_type: "drug"
        };
        addCart(params).then(({ data }) => {
          this.$message({ message: "添加成功!", type: "success" });
        });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    /**
     * 根据指定id 获取商品
     */
    async _getAllGoods(item_id) {
      let params = {
        item_type: "normal",
        item_id,
        page: 1,
        pageSize: 50
      };
      let { data } = await getAllGoods(params);
      this.goodsList = data.list;

      let itemIdList = this.itemIdList;
      let tabList = this.tabList.map(item => {
        data.list.forEach(row => {
          if (item.childrenIdList.includes(row.item_id)) {
            (row.goodsId = row.itemId),
              (row.brand = row.brand_logo),
              (row.imgUrl = row.pics[0]),
              (row.title = row.itemName),
            item.children.push(row);
          }
        });
        return item;
      });
      this.dataForm.tabList = tabList;
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" rel="stylesheet/scss">
.floor {
  .el-tabs__header {
    margin: 0;
    border-bottom: 1px solid #d4d4d4;
  }
  .el-tabs__content {
    display: none;
  }
  .el-tabs__nav {
    float: right;
  }
  .el-tabs__nav {
    border: none !important;
    > div {
      margin-right: 10px;
      border: 1px solid #d4d4d4;
      border-left: 1px solid #d4d4d4 !important;
    }
  }
  .el-image {
    cursor: pointer;
  }
}
.floor-content {
  flex: 1;
  .tabsBar {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .good-item {
      height: 280px;
      border-right: 1px solid #e9e9e9;
      border-bottom: 1px solid #e9e9e9;
      padding: 10px;
      &:hover {
        box-shadow: 1px 1px 20px #999;
        .good-price {
          &.pr-n {
            p {
              display: block;
            }
          }
          p {
            display: block;
          }
        }
        .ds {
          display: block;
        }
      }
      .good-img {
        img {
          display: block;
          width: 100%;
          height: 170px;
          margin: 0;
        }
      }
      .good-price {
        margin-top: 2px;
        .main-btn {
          font-size: 12px;
          height: 25px;
          width: 80px;
          line-height: 28px;
        }
      }
      .good-title {
        font-size: 12px;
        // height: 38px;
        // line-height: 38px;
        cursor: pointer;
        text-align: left;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0;
      }
      .distributor-info {
        padding: 0;
        margin-top: 3px;
      }
      .good-item__tag {
        padding: 0px;
      }
      h3 {
        display: none;
      }
      .good-price {
        font-weight: 500;
        font-size: 12px;
        text-align: left;
      }
      .ds {
        width: auto;
        display: block;
        right: 0;
        a {
          display: none;
        }
      }
    }
  }
  &__goods {
    height: 280px;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    padding: 10px;

    > p {
      font-size: 12px;
      height: 38px;
      cursor: pointer;
    }

    .content-goods__footer {
      overflow: hidden;
      height: 45px;

      .goods-footer__price {
        float: left;

        span {
          font-size: 12px;
          text-decoration: line-through;
          color: #888;
        }
        p {
          font-size: 14px;
          color: #e54e44;
          line-height: 46px;
        }
      }
      .goods-footer__submit {
        float: right;
        margin-top: 9px;
      }
    }
  }
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
.floor {
  position: relative;
  margin-bottom: 40px;
  > h2 {
    left: 24px;
    top: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #626262;
    position: absolute;
  }
  .floor-tabs {
    background: #ffffff;
    padding-top: 20px;
  }

  .floor-box {
    display: flex;
    height: 560px;
    background: #ffffff;
    overflow: hidden;

    .floor-left {
      width: 250px;
      background: #ccc;

      &__top {
        height: 120px;
        // width: 175px;
        margin: 0 auto;
        // padding-top: 55px;
        position: relative;
        z-index: 9;
        background: #fff;

        .goods—type__link {
          height: 40px;
          line-height: 40px;
          width: 80px;
          text-align: center;
          font-size: 12px;
          color: white;
          cursor: pointer;
          span {
            padding: 2px;
          }
        }
      }

      &__footer {
        height: 440px;
        position: relative;
        z-index: 9;
        cursor: pointer;

        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .floor-right {
      width: 155px;
      height: 560px;
      background: #ccc;
      div {
        cursor: pointer;
        width: 155px;
        height: 280px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// floor.vue?5a242d9a